export { getTextLineCount } from "./get-text-line-count";
